const faqs = [
  {
    id: 'Q1',
    title: '个人信息包括什么？',
    content:
      `保护您的隐私是我们的核心价值观之一，也是我们的首要任务。

个人信息数据是指，任何指向一个已识别或可识别的自然人（“数据主体”）的信息。该可识别的自然人能够被直接或间接地识别。
      
敏感个人信息是指，揭示种族或民族、政治观点、宗教或哲学信仰、工会成员的个人数据。以及以识别自然人为唯一目的的基因数据、生物特征数据、健康、自然人的性生活或性取向的数据。以及未成年人数据。
      
根据各个国家/地区隐私保护法律法规要求，个人信息和敏感个人信息的定义或有差异。我们致力于建立标准化、可持续的隐私影响评估程序，以确保我们的产品和服务始终符合个人信息保护相关的法律法规。`,
  },
  {
    id: 'Q2',
    title: '小米如何收集和使用我的个人信息？',
    content:
      `小米为用户提供多样化的产品与服务。在您使用我们的产品或服务时，我们只会收集为实现具体、特定、明确及合法的目的所必需的信息，并且不会对这些信息进行与上述目的不相符的进一步处理。收集个人信息的目的在于向您提供产品或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。
 
通常情况下，您可以阅读[小米隐私政策](https://privacy.mi.com/all/zh_CN/)，以详细了解我们如何收集和使用您的个人信息。由于小米提供的产品或服务具有差异性，若某款小米产品或服务有单独的隐私政策，则该单独隐私政策将被优先适用。同时，由于您所使用的设备机型、服务版本或所在位置等因素，特定产品或服务如何收集、处理您的个人信息也可能有所不同。我们建议您参阅单独的隐私政策以获取详细信息。`,
  },
  {
    id: 'Q3',
    title: '在哪里可以阅读小米隐私政策？',
    content:
      `您可以登录小米官网查看小米集团隐私政策，您还可以在其他小米App中查看各产品/服务独立的隐私政策。`,
  },
  {
    id: 'Q4',
    title: '我的个人信息会分享给第三方吗？',
    content:
      `小米充分尊重用户的隐私，但为保证向您提供优质的服务，我们可能会向合作伙伴等第三方共享必要的个人信息。

为了您能够清晰、容易的了解我们与第三方共享了哪些数据，我们在各产品/服务的独立隐私政策中写明了第三方数据共享清单，您可以详细查看。`,
  },
  {
    id: 'Q5',
    title: 'MIUI系统如何保护我的安全和隐私？',
    content:
      `小米设计的MIUI以安全性和易用性为核心，软件、硬件和服务在每台小米手机上紧密集成、协同工作，为用户提供端到端的安全保护。其中既包括硬件芯片、系统内核、数据安全等基础安全能力， 也包括帐号、支付、云服务、语音 AI、图像 AI 等一系列关键服务的信息安全与隐私保护。您可以阅读在[信任中心](https://trust.mi.com/zh-CN)发布的《MIUI安全与隐私白皮书》获取详细内容。
 
MIUI也为您提供了多种进行隐私管控的功能和选项，以确保您的隐私在您的掌控之中。具体信息可以浏览[小米隐私网站](https://privacy.miui.com/#/)。`,
  },
  {
    id: 'Q6',
    title: '小米如何保证我的数据安全？',
    content: `我们承诺保证您的个人信息安全。为了防止未经授权的访问、披露或其他类似风险，我们落实了所有法律规定的物理、电子和管理措施流程，保护我们从您的移动设备和小米网站上收集的信息。我们将确保依据适用的法律保护您的个人信息。
 
您可登录[小米信任中心](https://trust.mi.com/zh-CN)查看我们在隐私保护方面做了哪些努力。`,
  },
  {
    id: 'Q7',
    title: '什么是小米隐私支持？',
    content:
      `小米隐私支持将帮助您解决隐私方面存在的问题，包括但不限于：  

1. 行使您所在地区法律赋予的个人信息主体权利。  
2. 提出隐私问题或建议，如隐私投诉、报告未成年人相关问题、报告数据泄露问题、提出隐私相关建议等。  
3. 其他隐私咨询。

您可登录[小米隐私支持页面](https://privacy.mi.com/support/contact?locale=zh-cn)，选择“提交问题”。在后续出现的页面中，根据您的需要和页面提示，完成相关内容的填写后即可向我们发出隐私问题申请，我们将在 15 个工作日内处理您的请求。`,
  },
  {
    id: 'Q8',
    title: '什么是个人信息主体权利？',
    content:
      `小米非常重视您的个人信息安全和隐私，我们坚持符合全球隐私规范要求，为您提供您的合法权益。

数据主体权利 (DSR) 是指个人或“数据主体”拥有对其隐私的知情权与控制权。包括查看、更正、导出和删除其保存在小米的个人数据的权利。
      
为此，小米推出了一项[在线服务](https://account.xiaomi.com/fe/service/account/privacy)，用于帮助您了解、访问和控制您存储的个人信息。`,
  },
  {
    id: 'Q9',
    title: '如何行使您的个人信息主体权利？',
    content:
      `小米尊重并保障用户的数据安全与隐私，致力于打造让用户信任的产品和服务，享受科技的乐趣。

1. 您可通过[小米官网](https://www.mi.com/)【小米账户】->【隐私中心】和登录[小米云服务](https://i.mi.com/)来行使您的查询权、复制权、删除权等权利。
2. 您可通过阅读[小米隐私政策](https://privacy.mi.com/all/zh_CN/)和各小米产品或服务单独的隐私政策，来行使您的知情权。
3. 您可通过[小米官网](https://www.mi.com/)【小米账户】->【个人信息】来行使您的更正权。
4. 您可通过各小米产品或服务内的个性化功能控件来行使自动化决策相关权利。
5. 您还可以通过此[隐私支持](https://privacy.mi.com/support/?locale=zh-cn)行使其他权利。`,
  },
  {
    id: 'Q10',
    title: '如何查询您的个人数据？',
    content:
      `通常情况下，您可以阅读[小米隐私政策](https://privacy.mi.com/all/zh_CN/)，以详细了解我们如何收集和使用您的个人信息。由于小米提供的产品或服务具有差异性，若某款小米产品或服务有单独的隐私政策，则该单独隐私政策将被优先适用。
 
另外，您也可以通过以下方式了解您在使用小米产品或服务时产生了哪些个人信息。

1. 您可登录您的帐号查阅您的个人基本信息，打开[小米官网](https://www.mi.com/)，点击右上角【登录】->【小米账户】->【个人信息】来查看或更改您的个人信息。
2. 您可以登录您的[小米云服务](https://i.mi.com/)，来查看您存储在小米云中的数据。
3. 您也可以使用[隐私和数据管理工具](https://account.xiaomi.com/fe/service/account/privacy)下载并查看您的数据，打开小米官网，点击右上角【登录】->【小米账户】->【隐私中心】，通过安全验证后，选择【管理您的数据】和【下载小米帐号个人资料】，选择您想查阅的小米产品或服务数据，点击【下载】后即在PC中查阅您的数据。
      
若您有其他隐私疑问可以联系我们的隐私团队。`,
  },
  {
    id: 'Q11',
    title: '如何下载您的个人数据？',
    content:
      `小米致力于保护用户隐私安全的同时提升用户体验，我们帮助用户了解并掌握其隐私。您可以通过以下方式下载您的个人数据。

1. 您可以使用[隐私和数据管理工具](https://account.xiaomi.com/fe/service/account/privacy)下载您的数据，打开小米官网，点击右上角【登录】->【小米账户】->【隐私中心】，通过安全验证后，选择【管理您的数据】和【下载小米帐号个人资料】，选择您想查阅的小米产品或服务数据，点击【下载】。
      
2. 您可以登录您的[小米云服务](https://i.mi.com/)，来下载您存储在小米云中的数据。
      
我们会以易于使用和阅读的行业标准格式提供您的数据。非结构化数据，如照片、视频、文档等会以原始格式提供。结构化数据，如应用使用信息会以.csv格式提供。数据准备好后，我们会通知您前往下载。
其他我们没有提供的数据，则此类数据不是您的个人信息；或，此类信息不与您的小米帐号关联。
      
若您有其他隐私疑问可以联系我们的隐私团队。`,
  },
  {
    id: 'Q12',
    title: '我有多个小米帐号，我能一次性获得所有帐号储存的数据副本吗？',
    content:
      `不能。每个小米帐号都是唯一的。如果您想要获得多个小米帐号下存储的个人数据副本，请分别登录每个帐号提交请求。`,
  },
  {
    id: 'Q13',
    title: '我可以将我的数据传给其他产品/服务提供商吗？',
    content:
      `我们将以行业标准格式提供给您数据，所以数据可以便捷的导入到其他产品/服务。您下载数据后，便可以将数据转移给其他产品/服务提供商。但我们仍然建议您谨慎的进行数据转移操作，比如，不要在第三方的电脑中进行操作。不要未经过客观验证就转移数据给其他第三方等。从而避免您的个人数据泄露。`,
  },
  {
    id: 'Q14',
    title: '如何删除数据？',
    content:
      `小米尊重用户隐私，保护用户隐私安全的同时提升用户对个人信息的控制。您可以通过以下方式删除您的个人数据。

1. 您可以通过[隐私和数据管理工具](https://account.xiaomi.com/fe/service/account/privacy)删除您希望删除的数据，打开小米官网，点击右上角【登录】->【小米账户】->【隐私中心】，通过安全验证后，选择【管理您的数据】后选择您想删除的小米产品或服务数据。
2. 您可在【隐私中心】选择【注销帐号】来删除您小米帐号下所有的数据以及副本。
3. 您可以登录您的[小米云服务](https://i.mi.com/)，来删除您存储在小米云中的数据。
      
若您有其他隐私疑问可以联系我们的隐私团队。`,
  },
  {
    id: 'Q15',
    title: '如何更正数据？',
    content:
      `小米尊重用户隐私，保护用户隐私安全的同时提升用户对个人信息的控制。您可以使用通过[小米帐号](https://account.xiaomi.com/)来更正/补充您的个人隐私数据。

1. 您可以登录您的帐号更正/补充您的基本信息，打开小米官网，点击右上角【登录】->【小米账户】->【个人信息】进行修改。
2. 您可以登录您的帐号更正/补充您的绑定手机号码或邮箱信息，点击右上角【登录】->【小米账户】->【登录与安全】进行修改。
      
如果您已无法登录您的小米帐号，或邮件地址和手机号码已不可用，您可以联系[小米客服](https://privacy.mi.com/support/service?locale=zh-cn)解决。`,
  },
  {
    id: 'Q16',
    title: '如何注销小米帐号？',
    content:
      `小米充分保护您的隐私，并绝对尊重您对于您个人隐私数据享有的权利。您可以使用我们已上线的隐私和数据管理工具来注销您的小米帐号。

1. 请您点击此链接 https://account.xiaomi.com/pass/del ，自助进行帐号注销。
2. 在您提交注销账号申请前，请仔细阅读以下内容：  
  1）在您注销前请从所有设备退出登录该账号，并确保所有关联服务已关闭。  
  2）您注销小米账号后，将不能再使用关联服务，与之相关联的个人数据也将被删除。
      `,
  },
  {
    id: 'Q17',
    title: '如何关闭个性化服务？',
    content:
      `小米充分尊重用户的选择和合法权利，为了使您更加舒心的使用小米产品和服务，小米为您提供了针对个性化服务的控制功能。

1. 您可通过系统安全设置统一控制系统应用的个性化广告服务，您可以参照下方的操作指引：  
  1）针对MIUI 12：  
  依次点击：【设置】->【密码与安全】->【系统安全】->【广告服务】，之后您便可以开启/关闭个性化广告推荐。  
  2）针对MIUI 11：    
  依次点击：【设置】->【密码、隐私与安全】->【系统安全】->【广告服务】，之后您便可以开启/关闭个性化广告推荐。  
  3）针对MIUI 10：  
  依次点击：【设置】->【系统设置】->【更多设置】->【系统安全】->【广告服务】，之后您便可以开启/关闭个性化广告推荐。  
2. 您可通过小米产品或服务自身提供的个性化控制功能来开启/关闭个性化服务。不同的小米产品或服务的控制方式并不相同，您可以在该产品的隐私政策中了解具体的方法和步骤。  
      
若您有其他隐私疑问可以联系我们的隐私团队。`,
  },
  {
    id: 'Q18',
    title: '帐号相关问题应该如何处理？',
    content:
      `若您有小米帐号相关问题，如忘记密码、更换绑定邮箱、帐号找回等，可联系我们的[客户服务团队](https://privacy.mi.com/support/service?locale=zh-cn)，获取进一步的帮助。`,
  },
  {
    id: 'Q19',
    title: '手机软硬件使用问题如何处理？',
    content:
      `若您存在以下问题：

1. 与MIUI系统、系统应用或其他小米互联网应用服务相关的使用问题（例如，如何进行系统升级，如何使用小米云、如何使用相关App等）。
2. 与小米手机、电视等硬件品设备硬件有关的使用问题（例如，如何解锁手机，如何进行固件升级，如何解决设备故障等）。
3. 与产品购买与售后服务相关的问题（例如，如何预约购买手机，如何进行退换货等）。

请联系我们的[客户服务团队](https://privacy.mi.com/support/service?locale=zh-cn)，获取进一步的帮助。`,
  },
  {
    id: 'Q20',
    title: '手机丢失怎么办？',
    content:
      `您可以尝试以下方式：

1. 若已激活查找手机：
请登录https://i.mi.com 点击【查找设备】，找到丢失设备后开启【丢失模式】。丢失模式下手机将无法被解锁或访问，强制刷机会清空所有数据，待手机找回后可解锁激活。
2. 若未开启查找手机：  
  1）建议立即访问https://id.mi.com 登录帐号修改密码。修改密码后帐号所有地方的登录态都会失效，从而保障帐号安全。  
  2）若无法登录帐号，请联系我们的[客户服务团队](https://privacy.mi.com/support/service?locale=zh-cn)，获取进一步的帮助。`,
  },
  {
    id: 'Q21',
    title: '如何查看或管理App的权限？',
    content:
`1.目前所有软件都可以通过长按App图标，点击【应用信息】，进入选择【权限管理】对App进行所有权限的管理。您可根据需要对相关App的权限自行管理配置。  
2.您也可以进入手机【设置】，选择【应用设置】，选择【授权管理】查看所有App的权限使用，并进行权限管理。`,
  },
  {
    id: 'Q22',
    title: '小米隐私保护功能是否可以关闭？',
    content:
      `保护用户的隐私一直是小米的核心价值观之一。我们遵循隐私保护的原则，在产品开发阶段采用隐私设计理念，并持续采用创新技术来保护用户的隐私。目前小米手机隐私保护相关功能暂无法关闭。
 
若您对小米的隐私保护相关内容仍有疑问，您可以登录小米隐私主页(https://privacy.miui.com/#/)查看我们为保护用户隐私都做了哪些努力，您也可以访问小米信任中心(https://trust.mi.com/)下载并查看《MIUI 安全与隐私白皮书》详细了解为实现保护用户的数据与隐私安全所使用的各种技术细节。`,
  },
  {
    id: 'Q23',
    title: '在售后维修期间，我的数据安全吗？',
    content:
      `小米公司以尊重和保护用户隐私与安全，致力于打造让用户信任的产品，享受科技的乐趣为目标。 
 
为确保信息安全与隐私保护策略的贯彻执行，小米在2014 年就正式成立信息安全与隐私委员会， 通过技术防护、流程制度、评估和审查机制等建立了完善的安全管理体系。同时，小米聘请了欧盟当地的资深律师作为欧盟业务的数据保护官，以确保小米符合各国法律法规的要求。 
     
为向用户提供符合法律法规及业界标准要求的业务运行环境及服务，小米已开展全球化合规治理工作，并接受外部监管机构的定期审查。小米MIUI 产品和服务的基础架构、开发、运维及互联网服务遵循国际权威认证体系， 已通过了英国标准协会（BSI）的ISO27001、ISO27018 和ISO29151 认证；MIUI12 已通过德国莱茵 TÜV 安卓系统增强隐私保护测试；MIUI 操作系统及其内置应用、云服务已经过全球领先的数据隐私 管理公司TrustArc 审核与确认，小米的隐私政策和隐私实践符合TrustArc 企业隐私与数据治理实践评估标准，并被授予TrustArc 认证的隐私印章。
      
基于小米的充分安全和合规建设，您可以信任小米在任何流程中可以充分保护您的数据安全。
      
若您对小米的隐私保护相关内容仍有疑问，您可以登录小米隐私主页(https://privacy.miui.com/#/)查看我们为保护用户隐私都做了哪些努力，您也可以访问小米信任中心(https://trust.mi.com/zh-CN/privacy)下载并查看《MIUI 安全与隐私白皮书》详细了解为实现保护用户的数据与隐私安全所使用的各种技术细节。`,
  },
  {
    id: 'Q24',
    title: '如果我有更多问题怎么办？',
    content:
      `如果上述常见问题帮助未解决您的问题，您也可以登录小米隐私支持(https://privacy.mi.com/support/?locale=zh-cn)，打开【提交问题】选项，根据页面提示完成问题提交，您需要注意以下几点：

1. 如果您的问题与隐私无关，如与系统升级、功能使用、产品故障及售后服务等有关的问题，可能无法正常收到我们的回复，针对此类问题，建议您请[联系客户服务团队](https://privacy.mi.com/support/service?locale=zh-cn)获取帮助。
2. 您需要根据提示选择您的国家/地区，各国家/地区的法律不尽相同，我们需要您提供准确的信息以帮助您解决问题。
3. 问题描述尽量详细且准确。如有可能，请将问题截图上传给我们，以帮助我们更快的定位您的问题。`,
  },
  {
    id: 'Q25',
    title: '我有隐私建议应该联系谁？',
    content:
      `小米安全和隐私办公室非常欢迎您提出隐私相关建议，同样的，您可以登录小米隐私支持(https://privacy.mi.com/support/?locale=zh-cn)，打开【提交问题】选项，根据页面提示选择【隐私问题咨询与建议】来提出您的建议。`,
  },
];

export default faqs;
